//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
    };
  },
  created () {
    document.body.style.backgroundImage = 'url(static/images/queue/bg.png)';
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundAttachment = 'fixed';
    document.body.style.backgroundSize = 'cover';
  },
  destroyed () {
    document.body.style.backgroundImage = 'none';
  }
};



// WEBPACK FOOTER //
// ./src/components/queue/Index.vue